<script lang="ts">
	import type { PageData } from './$types'
	import { onMount, type Snippet } from 'svelte'
	import { injectSpeedInsights } from '@vercel/speed-insights/sveltekit'
	import { beforeNavigate } from '$app/navigation'
	import { appState } from '$lib/app-state.svelte'
	import { callback } from '$lib/google.svelte'
	import { config } from '$lib/config'
	import { loadingOfGlobal } from '$lib/global'
	import Header from '$lib/public/layout/Header.svelte'
	import Footer from '$lib/public/layout/Footer.svelte'
	import LocationModal from '$lib/public/layout/LocationModal.svelte'
	import ContactOffcanvas from '$lib/public/layout/ContactOffcanvas.svelte'
	import CartOffcanvas from '$lib/public/layout/CartOffcanvas.svelte'
	import Toast from '$lib/public/layout/Toast.svelte'
	// import Turnstile from '$lib/public/Turnstile.svelte'
	import '../app.css'

	interface Props {
		data: PageData
		children?: Snippet
	}

	injectSpeedInsights()

	let { data, children }: Props = $props()
	const { master } = data

	appState.initializePublic(master)
	appState.user = data.user

	beforeNavigate(() => {
		// does not fire for hash routes
		let expirationDate = appState.user?.expires ? new Date(appState.user.expires) : undefined

		if (expirationDate && expirationDate < new Date()) {
			console.log('Login session expired.')
			appState.user = null
		}
	})

	onMount(async () => {
		await loadingOfGlobal('google')
		google.accounts.id.initialize({
			client_id: config.googleClientId,
			callback, // JavaScript function that handles ID tokens. Google One Tap and the Sign In With Google button popup UX mode use this attribute.
			use_fedcm_for_prompt: true // Allow the browser to control user sign-in prompts and mediate the sign-in flow between your website and Google.
		})
		if (!appState.user) google.accounts.id.prompt()
	})
</script>

<Header />

<main
	class="tw:mx-auto tw:w-full tw:px-3 tw:bs-sm:max-w-bs-sm tw:bs-md:max-w-bs-md tw:bs-lg:max-w-bs-lg tw:bs-xl:max-w-bs-xl tw:bs-xxl:max-w-bs-xxl">
	{@render children?.()}
</main>

<Footer />

{#each appState.locations as location}
	<LocationModal {location} />
{/each}

<Toast />

<ContactOffcanvas />

<CartOffcanvas />

<!-- <Turnstile /> -->
